// Templates API endpoints - all endpoints are relative to the AP_API_BASE_URL
export const TEMPLATES_ENDPOINTS = {
    // Templates management
    TEMPLATES: '/templates',
    TEMPLATE_BY_ID: (templateId: string) => `/templates/${templateId}`,
    
    // Flows management (for creating flow from template)
    FLOWS: '/flows',
    FLOW_BY_ID: (flowId: string) => `/flows/${flowId}`,
} as const;

// Helper to format piece name for display (remove @activepieces/piece- prefix)
export const formatPieceName = (pieceName: string): string => {
    // Handle @activepieces/piece-xxx format
    if (pieceName.includes('/piece-')) {
        return pieceName.split('/piece-').pop() || pieceName;
    }
    // Handle @voicebot/piece-xxx format
    if (pieceName.includes('/piece-')) {
        return pieceName.split('/piece-').pop() || pieceName;
    }
    // Handle piece-xxx format
    if (pieceName.startsWith('piece-')) {
        return pieceName.replace('piece-', '');
    }
    return pieceName;
};

// Helper to get unique pieces from a template
export const getUniquePieces = (pieces: string[]): string[] => {
    return [...new Set(pieces)];
};

// Helper to format piece name for display with proper capitalization
export const formatPieceDisplayName = (pieceName: string): string => {
    const name = formatPieceName(pieceName);
    // Capitalize first letter and replace hyphens with spaces
    return name
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};
